import type { To } from 'react-router-dom';

const ALIASES: Readonly<Record<string, string>> = {
  portafolio: 'investments',
  portafolios: 'investments',
  portfolio: 'investments',
  portfolios: 'investments',
  inversiones: 'investments',
  investimentos: 'investments',
  portefolio: 'investments',
  portfólio: 'investments',
  portefólio: 'investments',
  planilla: 'sheets',
  planillas: 'sheets',
  planilha: 'sheets',
  planilhas: 'sheets',
  sheet: 'sheets',
  hoja: 'sheets',
  hojas: 'sheets',
  folha: 'sheets',
  folhas: 'sheets',
  configuracion: 'settings',
  configuración: 'settings',
  configuracao: 'settings',
  configuração: 'settings',
  configuracoes: 'settings',
  configurações: 'settings',
  usuarios: 'admin',
  usuários: 'admin',
  administracion: 'admin',
  administración: 'admin',
  administracao: 'admin',
  administração: 'admin',
  formularios: 'forms',
  formulario: 'forms',
  formulários: 'forms',
  formulário: 'forms',
  spreadsheet: 'sheets',
  'hoja-de-calculo': 'sheets',
  'folha-de-calculo': 'sheets',
  trip: 'trips',
  calendario: 'calendar',
  calendário: 'calendar',
};

export const ROUTE_ALIAS_KEYS = Object.keys(ALIASES);

export function aliasTarget(pathname: string, search = '', hash = ''): To | null {
  const segments = pathname.split('/').filter(Boolean).map((segment) => {
    try {
      return decodeURIComponent(segment);
    } catch {
      return segment;
    }
  });
  const first = segments[0]?.toLocaleLowerCase('pt-BR');
  if (!first) return null;
  const target = ALIASES[first];
  if (!target) return null;
  const suffix = segments.slice(1).join('/');
  return `/${target}${suffix ? `/${suffix}` : ''}${search}${hash}`;
}
